export default __webpack_public_path__ + "static/media/29-ART-(8-2).89600b42.jpg";